import Vue from 'vue'
import axios from "axios"
import {ErrorModal} from "../../Modals/ErrorModal"
import {API_URL} from "../../utils/consts";
import {formatPrice} from '../../utils/priceFormatter'

export default Vue.component('bid-button', {
  props: ['minbid', 'isTest', 'currency', 'monetization', 'auctionFinished', 'isAuctionRunning', 'service'],

  data() {
    return {
      bid: 0,
      money: {
        decimal: ',',
        thousands: ' ',
        precision: 0,
        suffix: ` ${this.currency}`,
        masked: false
      },
      pending: false
    }
  },

  computed: {
    isDisabled() {
      if (this.pending) {
        return true
      }

      if (!this.monetization) {
        return true
      }

      if (this.isDutch() || this.isJapan()) {
        return false
      }

      if (this.minbid) {
        return this.toPrice(this.bid.toString()) < this.minbid
      }

      return false
    }
  },

  created() {
    Event.listen('submitBid', bid => {
      this.submitBid({ resolution: true }, bid)
    })
  },

  methods: {
    isAuction() { return !this.monetization.mode },
    isEnglish() { return this.monetization.mode === 'english' },
    isDutch() { return this.monetization.mode === 'dutch' },
    isJapan() { return this.monetization.mode === 'japanese' },
    toPrice(str) { return parseFloat(str.toString().replace(/ /g, ''))},

    makeBid(quickBid = false) {
      if (this.isJapan()) {
        this.submitBid({}, null, quickBid)
      } else {
        this.$modal.show('bid-dialog')
      }
    },

    hideBidDialog() {
      this.bid = 0
      this.$modal.hide('bid-dialog')
    },

    async submitBid(payload = {}, forceBid = null, quickBid = false) {
      const bid = forceBid || this.toPrice(this.isDutch() || this.isJapan() ? this.monetization.info.actualPrice : this.bid)

      this.pending = true
      try {
        await this.service.bid(this.monetization.id, {bid, ...payload})
        this.bid = 0
        if (!this.isJapan()) {
          this.$modal.hide('bid-dialog')
        }
        let message
        if (this.isJapan()) {
          message = this.$i18n.t(`auctionRoom.bidButton.auction.${this.monetization.mode}.bidSubmitted.${payload?.resolution}`)
        } else {
          message = this.$i18n.t(`auctionRoom.bidButton.auction.${this.monetization.mode}.bidSubmitted`)
        }
        this.$toasted.show(message, {type: 'success', position: 'top-center', duration: 5000})
        if (!quickBid) {
          Event.fire('refreshMonetization')
        } else {
          Event.fire('quickBidButtonClose', this.monetization.id)
        }
        
      } catch (e) {
        ErrorModal.show(this, this.$i18n.t( e.response.data['errors']['code'] ? `auctionRoom.error.${e.response.data['errors']['code']}` : 'error.somethingWrong'))
      }
      this.pending = false
    },

    priceFormat(price) {
      return formatPrice(price)
    }
  }
});
